import { useCallback } from 'react';
import {
  type FavoritesArguments,
  type LifeCycleFn,
  useToggleFavorite as useToggleFavoriteCommon
} from '~/hooks/common/favorites';
import { useMaybeOpenReservableNotificationModal } from '~/hooks/vdp/favorites/useAddFavorite';
import { useBeforeRemoveFavorite } from '~/hooks/vdp/favorites/useRemoveFavorite';

type Options = {
  onAddFavorite?: LifeCycleFn;
};

export default function useToggleFavorite(
  opts: Options = {}
): (args: FavoritesArguments) => void {
  const maybeOpenReservableNotificationModal =
    useMaybeOpenReservableNotificationModal();

  const toggleFavorite = useToggleFavoriteCommon({
    beforeAddFavorite: useBeforeRemoveFavorite(),
    beforeRemoveFavorite: useBeforeRemoveFavorite(),
    onAddFavorite: opts.onAddFavorite ?? maybeOpenReservableNotificationModal
  });

  return useCallback(
    (args: FavoritesArguments) =>
      toggleFavorite({ nativeEventSource: 'vdp', ...args }),
    [toggleFavorite]
  );
}
